module.exports = __webpack_public_path__ + "static/media/viewport.e016b093.svg";